import { useContent } from "@/lib/content";
import { Seo } from "@/components/Seo";

export default function About() {
  const c = useContent("about");
  if (!c) return <div className="jt-container py-16 min-h-[60vh]"/>;
  const p = c.page;
  return (
    <div className="jt-container py-16 max-w-3xl" data-testid="about-page">
      <Seo title={c.seo.meta_title} description={c.seo.meta_description} image={c.seo.og_image || p.image}
        jsonLd={{ "@context": "https://schema.org", "@type": "TouristDestination", name: "Jawai, Rajasthan", description: c.seo.meta_description, image: p.image,
          geo: { "@type": "GeoCoordinates", latitude: 25.08, longitude: 73.16 }, touristType: ["Wildlife safari", "Birding", "Photography"] }}/>
      <div className="jt-eyebrow mb-3" data-testid="about-eyebrow">{p.eyebrow}</div>
      <h1 className="font-serif text-4xl md:text-5xl text-[#1E3A2B] mb-6" data-testid="about-title">{p.title}</h1>
      {p.image && <img src={p.image} alt={p.image_alt} className="rounded-2xl mb-8 aspect-[16/9] object-cover w-full" data-testid="about-image"/>}
      <div className="jt-prose" data-testid="about-body" dangerouslySetInnerHTML={{ __html: p.body_html }}/>
    </div>
  );
}
